import React from "react";
import "./Sass/style.scss";
import { BrowserRouter, Switch, Route, Link, Redirect, useHistory } from "react-router-dom";



function Privacy() {

    return (
      <div className="container mt-5">
        <h1 class="text-center">Privacy Policy</h1>

        <p>
          <strong>Effective Date: 02-06-2021</strong>
        </p>
        <h3>Your privacy is important to us</h3>

        <p>
          It is Error 5665's policy to respect your privacy regarding any
          information we may collect while operating our website. This Privacy
          Policy applies to <a href="https://Error5665.com"> Error5665.com</a>{" "}
          (hereinafter, "us", "we", or "Error5665.com"). We respect your privacy
          and are committed to protecting personally identifiable information
          you may provide us through the Website. We have adopted this privacy
          policy ("Privacy Policy") to explain what information may be collected
          on our Website, how we use this information, and under what
          circumstances we may disclose the information to third parties. This
          Privacy Policy applies only to information we collect through the
          Website and does not apply to our collection of information from other
          sources.
        </p>
        <p>
          This Privacy Policy, together with the Terms of service posted on our
          Website, set forth the general rules and policies governing your use
          of our Website. Depending on your activities when visiting our
          Website, you may be required to agree to additional terms of service.
        </p>
        <h2 id="tableofcontents">Contents</h2>
        <p>Click below to jump to any section of this privacy policy</p>
        <ol type="1">
          <li>
            <a href="#websitevisitors">
              <strong>Website Visitors</strong>
            </a>
          </li>
          <li>
            <a href="#Security">
              <strong>Security</strong>
            </a>
          </li>
          <li>
            <a href="#PIIProtection">
              <strong>
                Protection of Certain Personally-Identifying Information
              </strong>
            </a>
          </li>
          <li>
            <a href="#Ecommerce">
              <strong>E-commerce</strong>
            </a>
          </li>
          <li>
            <a href="#Credit">
              <strong>Contact Information</strong>
            </a>
          </li>
        </ol>
        <h2 id="websitevisitors">1. Website Visitors</h2>
        <p>
          Like most website operators, Error 5665 collects
          non-personally-identifying information of the sort that web browsers
          and servers typically make available, such as the browser type,
          language preference, referring site, and the date and time of each
          visitor request. Error 5665's purpose in collecting non-personally
          identifying information is to better understand how Error 5665's
          visitors use its website. From time to time, Error 5665 may release
          non-personally-identifying information in the aggregate, e.g., by
          publishing a report on trends in the usage of its website.
        </p>
        <p>
          Error 5665 also collects potentially personally-identifying
          information like Internet Protocol (IP) addresses for logged in users
          and for users leaving comments on https://Error5665.com blog posts.
          Error 5665 only discloses logged in user and commenter IP addresses
          under the same circumstances that it uses and discloses
          personally-identifying information as described below.
        </p>

        <p>
          <a href="#tableofcontents">Back to table of contents</a>
        </p>
        <h2 id="Security">2. Security</h2>
        <p>
          The security of your Personal Information is important to us, but
          remember that no method of transmission over the Internet, or method
          of electronic storage is 100% secure. While we strive to use
          commercially acceptable means to protect your Personal Information, we
          cannot guarantee its absolute security.
        </p>

        <p>
          <a href="#tableofcontents">Back to table of contents</a>
        </p>
        <h2 id="PIIProtection">
          3. Protection of Certain Personally-Identifying Information
        </h2>
        <p>
          Error 5665 discloses potentially personally-identifying and
          personally-identifying information only to those of its employees,
          contractors and affiliated organizations that (i) need to know that
          information in order to process it on Error 5665's behalf or to
          provide services available at Error 5665's website, and (ii) that have
          agreed not to disclose it to others. Some of those employees,
          contractors and affiliated organizations may be located outside of
          your home country; by using Error 5665's website, you consent to the
          transfer of such information to them. Error 5665 will not rent or sell
          potentially personally-identifying and personally-identifying
          information to anyone. Other than to its employees, contractors and
          affiliated organizations, as described above, Error 5665 discloses
          potentially personally-identifying and personally-identifying
          information only in response to a subpoena, court order or other
          governmental request, or when Error 5665 believes in good faith that
          disclosure is reasonably necessary to protect the property or rights
          of Error 5665, third parties or the public at large.
        </p>
        <p>
          If you are a registered user of https://Error5665.com and have
          supplied your email address, Error 5665 may occasionally send you an
          email to tell you about new features, solicit your feedback, or just
          keep you up to date with what's going on with Error 5665 and our
          products. We primarily use our blog to communicate this type of
          information, so we expect to keep this type of email to a minimum. If
          you send us a request (for example via a support email or via one of
          our feedback mechanisms), we reserve the right to publish it in order
          to help us clarify or respond to your request or to help us support
          other users. Error 5665 takes all measures reasonably necessary to
          protect against the unauthorized access, use, alteration or
          destruction of potentially personally-identifying and
          personally-identifying information.
        </p>

        <p>
          <a href="#tableofcontents">Back to table of contents</a>
        </p>
        <h2 id="Ecommerce">4. E-commerce</h2>
        <p>
          Those who engage in transactions with Error 5665 – by purchasing Error
          5665's services or products, are asked to provide additional
          information, including as necessary the personal and financial
          information required to process those transactions. In each case,
          Error 5665 collects such information only insofar as is necessary or
          appropriate to fulfill the purpose of the visitor's interaction with
          Error 5665. Error 5665 does not disclose personally-identifying
          information other than as described below. And visitors can always
          refuse to supply personally-identifying information, with the caveat
          that it may prevent them from engaging in certain website-related
          activities.
        </p>

        <p>
          <a href="#tableofcontents">Back to table of contents</a>
        </p>
        <h2 id="Credit">5. Contact Information</h2>
        <p>
          . If you have any questions about our Privacy Policy, please contact
          us at {" "}
          <a href="mailto:amzerror5665@gmail.com">amzerror5665@gmail.com</a>
        </p>

        <p>
          <a href="#tableofcontents">Back to table of contents</a>
        </p>
        <Link to="/">
          <button className="action-btn mt-4 mb-3">Back to Home</button>
        </Link>
      </div>
    );
}

export default Privacy;


// WEBPACK FOOTER //
// ./src/privacy.js